;
define("store_locator_list.tpl", function(){});

